import { motion } from "framer-motion";
import { ArrowUpRight, Copy } from "lucide-react";
import { toast } from "sonner";
import { profile } from "@/data/content";
import { Wordmark } from "./Logo";
import { EASE, SectionLabel, scrollToId } from "./Reveal";
import { MotionLines } from "./MotionLines";

const lines = ["Let's make", "learning move."];

export const Contact = () => {
  const copy = async () => {
    try { await navigator.clipboard.writeText(profile.email); toast.success("Email copied to clipboard"); }
    catch { toast.error("Couldn't copy. Please copy it manually."); }
  };

  return (
    <footer id="contact" className="relative overflow-hidden bg-[#05325F] pt-24 text-white md:pt-32" data-testid="contact-section">
      <div className="pointer-events-none absolute inset-x-0 bottom-56 top-0 md:bottom-48">
        <MotionLines id="contact-motion-path" tone="dark" inView testId="contact-line-drawing" />
      </div>
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <SectionLabel index="06" light>Contact</SectionLabel>
        <motion.h2 initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }} data-testid="contact-headline"
          className="text-5xl font-bold leading-[0.98] tracking-[-0.04em] sm:text-7xl lg:text-[7.5rem]">
          {lines.map((l, i) => (
            <span key={l} className="block overflow-hidden pb-[0.05em]">
              <motion.span className={`block ${i ? "text-[#8EC5EA]" : ""}`}
                variants={{ hidden: { y: "110%" }, show: { y: 0, transition: { duration: 1.1, delay: i * 0.12, ease: EASE } } }}>{l}</motion.span>
            </span>
          ))}
        </motion.h2>
        <div className="mt-12 flex flex-col gap-4 sm:flex-row sm:items-center">
          <a href={`mailto:${profile.email}?subject=Senior%20Project%20Officer%20%E2%80%94%20QVA`} data-testid="mailto-contact-button"
            className="group inline-flex items-center justify-between gap-6 rounded-full bg-white py-2 pl-7 pr-2 text-lg font-bold text-[#05325F] transition-colors hover:bg-[#F0F5FA]">
            <span className="break-all">{profile.email}</span>
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#005EB8] text-white transition-transform duration-500 group-hover:rotate-45">
              <ArrowUpRight className="h-5 w-5" />
            </span>
          </a>
          <button onClick={copy} data-testid="copy-email-button"
            className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/40 px-6 py-4 font-bold transition-colors hover:border-white">
            <Copy className="h-4 w-4" /> Copy email
          </button>
        </div>
        <div className="mt-24 grid gap-8 border-t border-white/15 py-10 text-sm text-[#D6E4F2] md:grid-cols-3">
          <button onClick={() => scrollToId("top")} className="text-left" data-testid="footer-logo"><Wordmark name={profile.name} invert /></button>
          <p data-testid="footer-location">{profile.location} · {profile.phone}<br /> </p>
          <p data-testid="footer-acknowledgement"> I acknowledge the Traditional Owners of the lands on which I live and work, and pay my respects to Elders past and present.</p>
        </div>
        <p className="pb-8 text-xs text-[#BFD8EE]">© {new Date().getFullYear()} {profile.name}.</p>
      </div>
    </footer>
  );
};
